import { Component } from "react";
import { withRouter } from '../../common/with-router';
import { isSuperUser } from '../../common/userUtils';
import { Card, Form, Button, Row, Col, Spinner, Accordion, Nav, Tab, Tabs } from "react-bootstrap";
import { FaSearch, FaEraser, FaEnvelope } from "react-icons/fa";
import { FiHelpCircle } from 'react-icons/fi';
import api from "../../services/api";
import { getCurrentUser } from '../../common/utils';
import Paginacao from '../../common/pagination';
import AsyncSelect from 'react-select/async';
import RegistrarDuvidaModal from "./RegistrarDuvidaModal";
import faqAreasService from "../../api/faq/faqAreasService";
import programaFaqService from "../../api/faq/programaFaqService";
import programaFaqConfigService from "../../api/faq/programaFaqConfigService";
import FaqRecebidas from "./FaqRecebidas";

class FAQ extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            loading: false,
            error: "",
            dados_usuario: null,

            ambiente_programa_id: null,
            programaSelecionado: null,
            busca: "",

            faqs: [],
            total: 0,
            page_numb: 1,
            
            showModalDuvida: false,
            searchTimeout: null,

            allFaqAreas: [],
            allowedAreas: [],
            selectedAreaId: 'all',
            fetchingAreas: false,
            activeTab: 'all',
            
            // Main Tabs
            mainTabKey: 'perguntas'
        };
    }

    componentWillUnmount() {
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
    }

    componentDidMount() {
        const dados_usuario = getCurrentUser();
        const ambiente_programa_id = dados_usuario?.ambiente_programa_id || null;

        this.setState(
            {
                dados_usuario, 
                ambiente_programa_id, 
                programaSelecionado: ambiente_programa_id ? { value: ambiente_programa_id, label: "Carregando..." } : null,
            },
            () => {
                if (ambiente_programa_id) {
                     api.get(`/programas/${ambiente_programa_id}/`)
                        .then(res => {
                             this.setState({
                                 programaSelecionado: { value: ambiente_programa_id, label: res.data.nome }
                             });
                        })
                        .catch(() => {
                            this.setState({
                                 programaSelecionado: { value: ambiente_programa_id, label: "Programa do Ambiente" }
                            });
                        });
                }
                this.carregarAreasGlobais().then(() => {
                    this.carregarDadosIniciais();
                });
            }
        );
    }

    carregarAreasGlobais = async () => {
         try {
             const response = await faqAreasService.getAll({ ativo: true });
             this.setState({ allFaqAreas: response.data.results || [] });
         } catch (error) {
             console.error("Erro ao carregar áreas de FAQ:", error);
         }
    };

    carregarDadosIniciais = () => {
        this.verificarPermissoesArea().then(() => {
            this.carregarFaqs(1);
        });
    };

    verificarPermissoesArea = async () => {
        const { dados_usuario, allFaqAreas, programaSelecionado, ambiente_programa_id } = this.state;
        const programaId = ambiente_programa_id || programaSelecionado?.value;

        if (!programaId || !dados_usuario) {
            this.setState({ allowedAreas: [] });
            return;
        }

        if (isSuperUser(dados_usuario)) {
            this.setState({ allowedAreas: allFaqAreas, selectedAreaId: 'all' });
            return;
        }

        this.setState({ fetchingAreas: true });
        try {
            const response = await programaFaqConfigService.getConfig(programaId);
            const config = response.data.results && response.data.results.length > 0 ? response.data.results[0] : null;

            if (!config || !config.configuracao_areas) {
                 this.setState({ allowedAreas: [] });
            } else {
                const userEmail = dados_usuario.email;
                const allowed = [];
                const configAreas = config.configuracao_areas;

                allFaqAreas.forEach(area => {
                    let areaConfig = configAreas[area.id];
                    let emails = [];
                    if (Array.isArray(areaConfig)) {
                         emails = areaConfig;
                    } else if (areaConfig && areaConfig.emails) {
                         emails = areaConfig.emails;
                    }

                    if (emails.includes(userEmail)) {
                        allowed.push(area);
                    }
                });

                if (allowed.length === 0 && allFaqAreas.length > 0) {
                     allowed.push(...allFaqAreas);
                }

                this.setState({ allowedAreas: allowed, selectedAreaId: 'all' });
            }

        } catch (error) {
            console.error("Erro ao verificar permissões de área:", error);
            this.setState({ allowedAreas: [] });
        } finally {
             this.setState({ fetchingAreas: false });
        }
    };

    carregarProgramas = async (inputValue = "") => {
        try {
            const response = await api.get(`/programas/?nome=${encodeURIComponent(inputValue)}`);
            const opcoes = (response.data.results || []).map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            return [];
        }
    };

    carregarFaqs = async (page_numb = 1) => {
        this.setState({ loading: true, error: "" });

        try {
            const { ambiente_programa_id, programaSelecionado, busca, selectedAreaId, allowedAreas } = this.state;
            const programa_id = ambiente_programa_id || programaSelecionado?.value;
            
            if (!this.isSuperUser()) {
                 if (!programa_id) {
                     this.setState({ loading: false });
                     return;
                 }
            }

            const filters = {};
            if (busca && busca.trim() !== "") {
                filters.search = busca.trim();
            }

            if (selectedAreaId && selectedAreaId !== 'all') {
                filters.area_id = selectedAreaId;
            } 
            
            if (programa_id) {
                filters.programa_id = programa_id;
            }
            filters.page = page_numb;

            const response = await programaFaqService.getAll(filters);

            const results = Array.isArray(response.data) ? response.data : (response.data.results || []);
            const total = response.data.count ?? (Array.isArray(response.data) ? response.data.length : results.length);
            const next = response.data.next;
            const previous = response.data.previous;

            this.setState({
                faqs: results || [],
                total: total || 0,
                next,
                previous,
                loading: false,
                page_numb,
                activeTab: selectedAreaId || 'all',
            });
        } catch (error) {
            let erro_msg = "Erro ao carregar FAQ";
            if (error?.response?.status === 500) erro_msg = "Servidor indisponível no momento, tente novamente";
            if (error?.response?.status === 403) erro_msg = "Você não tem permissão para acessar essa área";

            this.setState({ loading: false, error: erro_msg });
        }
    };

    isSuperUser = () => {
         const { dados_usuario } = this.state;
         return dados_usuario?.tipo_usuario === "" || dados_usuario?.is_superuser;
    };


    onChangePrograma = (opt) => {
        this.setState(
            { programaSelecionado: opt }, 
            () => this.carregarDadosIniciais()
        );
    };

    handleAreaSelect = (eventKey) => {
        const key = eventKey === 'all' ? 'all' : parseInt(eventKey, 10);
        this.setState({ selectedAreaId: key }, () => this.carregarFaqs(1));
    };

    handleTabSelect = (eventKey) => {
        const key = eventKey === 'all' ? 'all' : parseInt(eventKey, 10);
        this.setState({ activeTab: key });
    };

    onChangeBusca = (e) => {
        const value = e.target.value;
        this.setState({ busca: value });

        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        const isSuper = this.isSuperUser();
        const hasArea = this.state.selectedAreaId && this.state.selectedAreaId !== '' && this.state.selectedAreaId !== 'all';

        // Only debounce search if:
        // 1. Text length > 1 (at least 2 chars)
        // 2. Or text is empty (handle clearing logic)
        if (value.length > 1) {
            const newTimeout = setTimeout(() => {
                this.carregarFaqs(1);
            }, 500);
            this.setState({ searchTimeout: newTimeout });
        } else if (value.length === 0) {
            // User cleared the input
            const newTimeout = setTimeout(() => {
                if (isSuper || hasArea) {
                    // Superuser or Normal User with Area selected -> Fetch (all or area-specific)
                    this.carregarFaqs(1);
                } else {
                    // Normal User, No Area, No Text -> Clear Results (Do not fetch all)
                    this.setState({ faqs: [], total: 0, loading: false });
                }
            }, 500);
            this.setState({ searchTimeout: newTimeout });
        }
    };

    onBuscar = (e) => {
        e.preventDefault();
        this.carregarFaqs(1);
    };

    onLimpar = () => {
        const isSuper = this.isSuperUser();
        this.setState(
            {
                busca: "",
                programaSelecionado: this.state.ambiente_programa_id ? { value: this.state.ambiente_programa_id, label: "Programa do Ambiente" } : null,
                selectedAreaId: isSuper ? 'all' : '',
                faqs: [],
                total: 0,
                next: null,
                previous: null,
            },
            () => this.carregarDadosIniciais()
        );
    };

    onClickPagina(num_page) {
        this.setState({ loading: true, page_numb: num_page }, () => this.carregarFaqs(num_page));
    }

    render() {
        const { loading, error, ambiente_programa_id, programaSelecionado, busca, faqs, total, page_numb, showModalDuvida, allowedAreas, selectedAreaId, fetchingAreas, dados_usuario, allFaqAreas, activeTab } = this.state;
        
        const programaIdAtual = ambiente_programa_id || (programaSelecionado ? programaSelecionado.value : null);

        const superUser = isSuperUser(dados_usuario);

        // Dynamically extract Unique Areas from the LOADED results
        const uniqueAreas = faqs.reduce((acc, faq) => {
            if (faq.dados_area && faq.dados_area.id) {
                if (!acc.some(a => a.id === faq.dados_area.id)) {
                    acc.push(faq.dados_area);
                }
            }
            return acc;
        }, []).sort((a, b) => a.nome.localeCompare(b.nome));

        return (
           <div>
                <Row className="align-items-center mb-3">
                    <Col sm={12} lg={12}>
                        <h4 className="page-title d-flex align-items-center gap-2">
                            <FiHelpCircle size={18} /> Central de Ajuda
                        </h4>
                    </Col>
                </Row>

                <Tabs 
                    defaultActiveKey="perguntas" 
                    id="faq-main-tabs" 
                    className="mb-3 aditus-tabs"
                >
                    <Tab eventKey="perguntas" title="Perguntas Frequentes">
                         <Card className="cardDestaque">
                            <Card.Body>
                                <Row className="mb-3">
                                    <Col xs={12} md={6}>
                                        <h4>Filtros</h4>
                                    </Col>
                                    <Col xs={12} md={6} className="text-end">
                                        {/* Botão visível apenas se houver um programa selecionado ou fixo no ambiente */}
                                        {programaIdAtual && (
                                            <Button variant="outline-primary" size="sm" onClick={() => this.setState({ showModalDuvida: true })}>
                                                <FaEnvelope className="me-1" /> Não encontrou sua dúvida? Clique aqui
                                            </Button>
                                        )}
                                    </Col>
                                </Row>

                                <Form method="get" onSubmit={this.onBuscar}>
                                    <Row>
                                        {!ambiente_programa_id && (
                                            <Col sm={3} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Programa</Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions
                                                        defaultOptions
                                                        loadOptions={this.carregarProgramas}
                                                        value={programaSelecionado}
                                                        onChange={this.onChangePrograma}
                                                        placeholder="Todos os Programas"
                                                        classNamePrefix="react-select"
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                        styles={{
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            menu: (base) => ({ ...base, maxHeight: '320px' }),
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}

                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Área</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="area_id"
                                                    value={selectedAreaId}
                                                    onChange={(e) => this.handleAreaSelect(e.target.value)}
                                                    disabled={!superUser && !programaIdAtual}
                                                >
                                                    <option value="all">Todas as Áreas</option>
                                                    {(superUser ? allFaqAreas : allowedAreas).map(area => (
                                                        <option key={area.id} value={area.id}>
                                                            {area.nome}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>

                                        <Col sm={!ambiente_programa_id ? 6 : 9} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Buscar FAQ</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="busca"
                                                    value={busca}
                                                    onChange={this.onChangeBusca}
                                                    placeholder="Digite sua dúvida..."
                                                    disabled={!superUser && !programaIdAtual}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {superUser && (
                                        <Button type="submit" variant="primary" size="sm" className="me-2">
                                            <FaSearch className="me-2" /> Buscar
                                        </Button>
                                    )}

                                    <Button type="button" size="sm" variant="light" onClick={this.onLimpar}>
                                        <FaEraser className="me-2" /> Limpar filtro
                                    </Button>
                                </Form>
                            </Card.Body>
                        </Card>

                        {/* Show Tabs ONLY if we have results AND more than 1 area type in the results */}
                        {(!fetchingAreas && (programaIdAtual || superUser) && total > 0 && uniqueAreas.length > 1) && (
                            <div className="mb-3 mt-3 p-3 d-flex justify-content-center" style={{ backgroundColor: '#252f4a', borderRadius: '15px' }}>
                                <Nav 
                                    variant="pills" 
                                    activeKey={String(activeTab)} 
                                    onSelect={this.handleTabSelect}
                                    className="justify-content-center flex-wrap gap-2"
                                    style={{ border: 'none' }}
                                >
                                    {(() => {
                                        const getLinkStyle = (key) => ({
                                            backgroundColor: String(activeTab) === String(key) ? '#bccd02' : '#ffffff',
                                            color: String(activeTab) === String(key) ? '#ffffff' : '#000000',
                                            borderRadius: '20px',
                                            padding: '8px 20px',
                                            fontWeight: '500',
                                            fontSize: '14px',
                                            border: 'none',
                                            cursor: 'pointer'
                                        });

                                        return uniqueAreas.map(area => (
                                            <Nav.Item key={area.id}>
                                                <Nav.Link eventKey={String(area.id)} style={getLinkStyle(area.id)}>{area.nome}</Nav.Link>
                                            </Nav.Item>
                                        ));
                                    })()}
                                </Nav>
                            </div>
                        )}

                        {fetchingAreas && (
                            <div className="text-center py-3">
                                <Spinner animation="grow" size="sm" /> Verificando permissões...
                            </div>
                        )}

                        {(loading || total > 0 || programaIdAtual || (busca && busca.trim() !== '') || (selectedAreaId && selectedAreaId !== 'all')) && (
                            <div className="mt-2 mb-2 text-muted">
                                Exibindo <b>{loading ? '...' : total}</b> FAQ(s)
                            </div>
                        )}

                        <Card className="hns-form-card mt-3">
                            <Card.Body>
                                {loading ? (
                                    <div className="faq-loading d-flex align-items-center">
                                        <Spinner animation="border" size="sm" className="me-2" />
                                        Carregando FAQ...
                                    </div>
                                ) : error ? (
                                    <div className="faq-error">{error}</div>
                                ) : faqs.length === 0 ? (
                                    <div className="text-center p-4">
                                        <p className="faq-empty mb-3">Nenhuma FAQ encontrada.</p>
                                        <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                                            Se não encontrou sua dúvida, nos envie no botão superior de envio de dúvidas.
                                            Selecione a área e em breve um responsável responderá.
                                        </p>
                                    </div>
                                ) : (
                                    <>
                                        {(() => {
                                            const groupedFaqs = faqs.reduce((acc, faq) => {
                                                const areaId = faq.dados_area?.id;
                                                if (activeTab !== 'all' && activeTab !== areaId) {
                                                    return acc;
                                                }

                                                const areaNome = faq.dados_area?.nome || "Outras";
                                                if (!acc[areaNome]) {
                                                    acc[areaNome] = [];
                                                }
                                                acc[areaNome].push(faq);
                                                return acc;
                                            }, {});

                                            const areas = Object.keys(groupedFaqs).sort();

                                            return areas.map(areaNome => (
                                                <div key={areaNome} className="mb-4">
                                                    {areas.length > 0 && (
                                                        <h5 className="border-bottom pb-2 mb-2 d-flex align-items-center" style={{ color: '#bccd02' }}>
                                                            {areaNome} 
                                                            <span className="badge bg-light text-dark ms-2" style={{fontSize: '0.7em'}}>{groupedFaqs[areaNome].length}</span>
                                                        </h5>
                                                    )}
                                                    <Accordion alwaysOpen className="faq-accordion">
                                                        {groupedFaqs[areaNome].map((faq, idx) => (
                                                            <Accordion.Item eventKey={String(faq.id)} key={faq.id} className="faq-item">
                                                                <Accordion.Header>
                                                                    <div className="faq-accordion-header">
                                                                        <div className="faq-pergunta">{faq.pergunta}</div>
                                                                        {isSuperUser(dados_usuario) ? (
                                                                            <div className="faq-programa small text-muted">
                                                                                {faq.programa_nome || (faq.dados_programa && faq.dados_programa.nome) || ""}
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </Accordion.Header>
                                                                <Accordion.Body>
                                                                    <div className="faq-resposta" dangerouslySetInnerHTML={{ __html: faq.resposta || "" }} />
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        ))}
                                                    </Accordion>
                                                </div>
                                            ));
                                        })()}

                                        {faqs && this.state.total && this.state.total > 0 && (
                                            <Paginacao 
                                                dados={{ count: total, next: this.state.next, previous: this.state.previous }} 
                                                loading={loading} 
                                                page_numb={page_numb} 
                                                _onClickPagina={this.onClickPagina} 
                                            />
                                        )}
                                    </>
                                )}
                            </Card.Body>
                        </Card>
                    </Tab>

                    <Tab eventKey="recebidas" title="Dúvidas Enviadas">
                        <FaqRecebidas />
                    </Tab>
                </Tabs>

                <RegistrarDuvidaModal 
                    show={showModalDuvida}
                    onHide={() => this.setState({ showModalDuvida: false })}
                    programaId={programaIdAtual}
                />
            </div>
        );
    }
}

export default withRouter(FAQ);
